// analytics.js
import ReactGA from 'react-ga4';
import { onCLS, onLCP, onINP, onTTFB, onFCP } from 'web-vitals';

export const initGA = () => {
    ReactGA.initialize(process.env.REACT_APP_MEASURE_ID, {
        gaOptions: {
            storage: 'none',
            storeGac: false,
            cookieFlags: 'SameSite=None; Secure',
        }
    });
};

export const trackPageview = (path) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};

// Track if web vitals have been initialized to prevent duplicate registrations
let webVitalsInitialized = false;

// Web Vitals tracking function
export const trackWebVitals = () => {
    // Only track if GA is initialized and we're in browser environment
    if (typeof window === 'undefined' || !process.env.REACT_APP_MEASURE_ID) {
        return;
    }

    // Prevent multiple registrations of web vitals callbacks
    if (webVitalsInitialized) {
        return;
    }

    try {
        // Mark as initialized before registering callbacks
        webVitalsInitialized = true;

        // Largest Contentful Paint
        onLCP((metric) => {
            ReactGA.event('lcp_web_vitals', {
                metric_value_ms: Math.round(metric.value),
                page_url: window.location.pathname,
                non_interaction: true,
            });
        });

        // Cumulative Layout Shift
        onCLS((metric) => {
            ReactGA.event('cls_web_vitals', {
                metric_value_unitless: Math.round(metric.value * 1000) / 1000, // Round to 3 decimal places
                page_url: window.location.pathname,
                non_interaction: true,
            });
        });

        // First Contentful Paint (replaces FID which is deprecated)
        onFCP((metric) => {
            ReactGA.event('fcp_web_vitals', {
                metric_value_ms: Math.round(metric.value),
                page_url: window.location.pathname,
                non_interaction: true,
            });
        });

        // Interaction to Next Paint
        onINP((metric) => {
            ReactGA.event('inp_web_vitals', {
                metric_value_ms: Math.round(metric.value),
                page_url: window.location.pathname,
                non_interaction: true,
            });
        });

        // Time to First Byte
        onTTFB((metric) => {
            ReactGA.event('ttfb_web_vitals', {
                metric_value_ms: Math.round(metric.value),
                page_url: window.location.pathname,
                non_interaction: true,
            });
        });

    } catch (error) {
        console.warn('Web Vitals tracking error:', error);
    }
};
